import { render, staticRenderFns } from "./fornecedor.vue?vue&type=template&id=4b13399c"
import script from "./fornecedor.vue?vue&type=script&lang=js"
export * from "./fornecedor.vue?vue&type=script&lang=js"
import style0 from "./fornecedor.vue?vue&type=style&index=0&id=4b13399c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports